import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_SIGNING_PENDING_TEMPLATE: NotificationConfiguration = {
  inapp: `Your signature is pending until tomorrow <b>{dueDate}</b>.`,
  email: {
    ctaKey: 'sign_now',
  },
};
